export const STORAGE_KEY = "rig_canvas:draft_board";
export const DRAFT_RIG_ID = "draft";

const INTERNAL_NODE_PROPS = ["selected", "dragging", "measured", "resizing", "draggable"];
const INTERNAL_EDGE_PROPS = ["selected"];

function stripNode(node) {
  const cleaned = { ...node };
  for (const prop of INTERNAL_NODE_PROPS) {
    delete cleaned[prop];
  }
  return cleaned;
}

function stripEdge(edge) {
  const cleaned = { ...edge };
  for (const prop of INTERNAL_EDGE_PROPS) {
    delete cleaned[prop];
  }
  return cleaned;
}

export function saveDraft(state) {
  const data = {
    nodes: state.nodes.map(stripNode),
    edges: state.edges.map(stripEdge),
  };
  if (state.rigName) data.rigName = state.rigName;
  if (state.rigDescription) data.rigDescription = state.rigDescription;
  if (state.rigNotes) data.rigNotes = state.rigNotes;
  if (state.rigCables) data.rigCables = state.rigCables;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function loadDraft() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const data = JSON.parse(raw);
    if (!Array.isArray(data.nodes) || !Array.isArray(data.edges)) return null;

    // Discard old-format drafts that contain cable nodes
    if (data.nodes.some((n) => n.type === "cable")) return null;

    return data;
  } catch {
    return null;
  }
}

export function clearDraft() {
  localStorage.removeItem(STORAGE_KEY);
}

const LAST_RIG_KEY = "rig_canvas:last_rig_id";

export function saveLastRigId(rigId) {
  if (rigId) {
    localStorage.setItem(LAST_RIG_KEY, rigId);
  }
}

export function loadLastRigId() {
  const val = localStorage.getItem(LAST_RIG_KEY);
  return val ? parseInt(val, 10) : null;
}
